export const validateStructureSetLabel = (
    newName: string
): [boolean, string | null] => {
    if (newName === '') {
        return [false, 'Structure set name cannot be empty.'];
    }
    if (/[^\x20-\x7E]/.test(newName)) {
        return [
            false,
            'Structure set name contains invalid characters. Only ASCII characters are allowed.',
        ];
    }
    if (newName.length > 16) {
        return [false, 'Structure set name must not exceed 16 characters.'];
    }
    if (newName.includes('\\')) {
        return [false, 'Structure set name cannot contain backslashes (\\).'];
    }
    return [true, null];
};

export const validateStructureName = (
    newName: string,
    structureNames: string[]
): [boolean, string | null] => {
    if (newName === '') {
        return [false, 'Structure name cannot be empty.'];
    }
    if (/[^\x20-\x7E]/.test(newName)) {
        return [
            false,
            'Structure name contains invalid characters. Only ASCII characters are allowed.',
        ];
    }
    if (newName.length > 16) {
        return [false, 'Structure name must not exceed 16 characters.'];
    }
    if (newName.includes('\\')) {
        return [false, 'Structure name cannot contain backslashes (\\).'];
    }
    if (
        structureNames.some(
            (name) => name.toLowerCase() === newName.toLowerCase()
        )
    ) {
        return [false, 'A structure with this name already exists.'];
    }
    return [true, null];
};
